import React from 'react';
import { Modal } from '@/components/ui';
import RoomQuotationTemplate from '../../../../utils/RoomQuotationTemplate';
import { fmt } from '../../../../lib/formatters';

export const InitialQuotationPreviewModal = ({ isOpen, onClose, lead }) => {
  if (!isOpen || !lead) return null;

  const getTemplateData = () => {
    // Try to find the items from the lead object
    let savedItems = lead.items || lead.quotationItems || lead.initialQuotationItems || [];
    
    // Sometimes it's inside quotationData
    if (lead.quotationData && lead.quotationData.items) {
      savedItems = lead.quotationData.items;
    }

    const roomsData = savedItems.map(roomData => {
      return {
        roomName: roomData.room || 'Room',
        items: (roomData.items || []).map(item => ({
          name: item.name,
          colour: item.color || item.colour || '-',
          type: item.category === 'internalType' ? 'Internal Type' : 
                item.category === 'shutterType' ? 'Shutter Type' : 
                item.category === 'blumItems' ? 'Hardware' : 
                item.category === 'customItems' ? 'Custom' : item.category || item.type || '-',
          warranty: item.warranty || '-',
          amount: fmt(parseFloat(item.unitPrice || item.amount || 0)),
          details: item.measurementInfo ? item.measurementInfo.split(' | ') : [],
          quantity: item.quantity || 1
        }))
      };
    });

    const amount = lead.quotationAmount || lead.amount || 0;

    return {
      projectName: lead.projectName || "-",
      clientName: lead.customerName || `${lead.firstName || ''} ${lead.lastName || ''}`.trim() || "-",
      date: new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }),
      site: lead.city || lead.location || "-",
      quotationNo: lead.customId ? `VK/${lead.customId.toUpperCase()}` : "-",
      contactRef: lead.phoneNumber || lead.phone || "-",
      designer: lead.projectManager?.name || lead.assignedTo?.name || "-",
      rooms: roomsData,
      totals: {
        total: fmt(amount),
        discount: "0",
        grandTotal: fmt(amount)
      }
    };
  };

  const templateData = getTemplateData();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="INITIAL QUOTATION PREVIEW"
      size="3xl"
      footer={
        <button
          type="button"
          onClick={onClose}
          className="px-6 cursor-pointer py-2.5 border border-slate-300 bg-white hover:bg-slate-50 text-slate-800 rounded-md text-[12px] font-semibold transition-all shadow-sm"
        >
          Cancel
        </button>
      }
    >
      <div className="flex flex-col p-1 bg-slate-50">
        <div className="w-full flex justify-center">
          <div className="border border-slate-200 rounded-xl shadow-inner bg-slate-200/50 p-2 sm:p-4 inline-block">
            <div style={{ zoom: '0.9' }}>
              <div className="bg-white shadow-xl mx-auto w-[800px]">
                <RoomQuotationTemplate data={templateData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InitialQuotationPreviewModal;
